import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from 'primereact/checkbox'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Editor } from "primereact/editor";
import { Calendar } from 'primereact/calendar'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { AuthContext } from '../../main/ProvedorAutenticacao'

import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import GrupoTrabalhoService from "../../app/service/GrupoTrabalhoService";
import AtividadeService from "../../app/service/AtividadeService";
import ProcessoService from "../../app/service/ProcessoService";

class AtividadeComponentInclusao extends Component {
	constructor(props) {
			super(props);

			this.state = {
				openSpinner: false,
				atividade: null,
				codigoAtividade: '',
				codigoProcesso: '',
				modalAtividadeInclusao: false,
				descricao: '',
				dtLimite: null,
				processo: null,
				//Atividade
				pesquisaProcesso: '',
				partes: [],
				titulos: [],
				tituloAtividade: null,
				grupoTrabalho: null,
				grupoTrabalhoDescricao: '',
				subGrupos: [],
				subGrupo: null,
				responsavel: null,
				responsaveis: [],
				interessado: null,
				interessados: [],
				hora: '',
				dtFatal: '',
				grau: [],
				codigoPublicacao: '',
			}

			this.tituloService = new TituloAtividadeService();
			this.grupoTrabalhoService = new GrupoTrabalhoService();
			this.atividadeService = new AtividadeService();
			this.processoService = new ProcessoService();

			this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
			this.onGrauChange = this.onGrauChange.bind(this);

			this.recorrencia = [
				{codigo: '2', nome: '2'},
				{codigo: '3', nome: '3'},
				{codigo: '4', nome: '4'},
				{codigo: '5', nome: '5'},
				{codigo: '6', nome: '6'},
				{codigo: '7', nome: '7'},
				{codigo: '8', nome: '8'},
				{codigo: '9', nome: '9'},
				{codigo: '10', nome: '10'},
				{codigo: '11', nome: '11'},
				{codigo: '12', nome: '12'},
				{codigo: '13', nome: '13'},
				{codigo: '14', nome: '14'},
				{codigo: '15', nome: '15'},
				{codigo: '16', nome: '16'},
				{codigo: '17', nome: '17'},
				{codigo: '18', nome: '18'},
				{codigo: '19', nome: '19'},
				{codigo: '20', nome: '20'},
				{codigo: '21', nome: '21'},
				{codigo: '22', nome: '22'},
				{codigo: '23', nome: '23'},
				{codigo: '24', nome: '24'}
		];
	}

	listarTitulosAtividade = async (empresa) => {
		this.tituloService.listar(empresa)
		.then(response => {
				this.setState({titulos: response.data});
		}).catch(error => {
				this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
		})
	}


	onGrauChange(e) {
		let selectedGrau = [...this.state.grau];

		if (e.checked)
		selectedGrau.push(e.value);
		else
		selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

		this.setState({ grau: selectedGrau });
	}

	pad2 = (n) => {
		return (n < 10 ? '0' : '') + n;
	}

	fecharModal() {
    this.props.onHide();
  }

	cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }  
    } else {
      if(this.state.tituloAtividade == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.subGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

     //Data Limite
     var tipoTarefa = '';
     var dataFormatadaDataLimite = '';
     if(this.state.dtLimite != '' && this.state.dtLimite != null) {
       var date = this.state.dtLimite;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
         dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
         tipoTarefa = 'A'
       } else {
          dataFormatadaDataLimite =  year+"-"+month+"-"+day;
          tipoTarefa = 'T';
       }
     }

     var dataFormatadaDataFatal = '';
     if(this.state.dtFatal != '' && this.state.dtFatal != null) {
       var date = this.state.dtFatal;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        } else {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day;
        }
    }

    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    };

    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const atividadeCadastro = {
      atividade: {
        titulo: titulo,
        processo: this.state.processo ? { codigo: this.state.processo.codigo } : null,
        subGrupo: this.state.subGrupo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        status: {
          codigo: 1 // Ativo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
        tituloAtividade: this.state.tituloAtividade,
        lancamentoFinanceiro: null,
        publicacao: this.state.codigoPublicacao ? { codigo: this.state.codigoPublicacao } : null
      },
      recorrencia: null,
      responsaveis: responsaveis,
      interessados: interessados,
      empresaId: usuarioLogado.empresa.codigo
    }

    this.setState({openSpinner: true});
    await this.atividadeService.cadastrarAtividade(atividadeCadastro)
      .then(response => {
        this.props.onHide();
        if (this.props.onAtividadeCriada) {
          this.props.onAtividadeCriada(response.data);
        }
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
				this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });
  }

	renderFooterAtividade(name) {
		return (
			<div className="left">
					<Button label="Cadastrar" 
									className="p-button-primary p-button-text"
									onClick={this.cadastrarAtividade}/>
					&nbsp;
					<Button label="Anexar" 
									icon="pi pi-paperclip"
									onClick={() => this.abrirModalAnexo('displayAnexoNovaAtividade')}
									className="p-button-help p-button-text"/>
					&nbsp;
					<Button
						label="Cancelar"
						className="p-button-secondary p-button-text"
						onClick={this.props.onHide}
            />
			</div>
		);
	}

	novaAtividade = async (processo) => {
		this.setState({processo: processo});
		if(processo.nrCnj != null) {
			this.setState({pesquisaProcesso: processo.nrCnj});
		}
		this.setState({partes: processo.partes});
		this.setState({grupoTrabalhoDescricao: processo.grupoTrabalho?.nome || ''});
		this.setState({subGrupos: processo.subGruposAtividades});
		this.setState({responsaveis: processo.usuariosAtividades});
		this.setState({responsavel: null});
		this.setState({interessados: processo.usuariosAtividades});
		this.setState({interessado: null});
		this.setState({titulos: processo.titulos});
		this.setState({tituloAtividade: null});
		this.setState({dtLimite: this.props.dtLimiteInicial || null});
		this.setState({dtFatal: ''});
		this.setState({hora: ''});
		this.setState({descricao: this.props.descricaoInicial || ''});

		let grauInicial = [];
		const urgencia = this.props.urgenciaResumo;
		if (urgencia) {
			const u = urgencia.toLowerCase();
			if (u.includes('alta')) {
				grauInicial = ['urgente'];
			} else if (u.includes('media') || u.includes('média')) {
				grauInicial = ['importante'];
			}
		}
		this.setState({grau: grauInicial});
	}

	abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

	async componentDidUpdate(prevProps){
		if(prevProps.processo !== this.props.processo && this.props.processo){
			this.setState({codigoPublicacao: this.props.publicacao ? this.props.publicacao.codigo : ''});
			await this.novaAtividade(this.props.processo);
		}
	}

	render() {
		const { visible, onHide } = this.props;
		return(
				<>
					<Toast ref={(el) => this.toast = el} />
					<Backdrop
						sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={this.state.openSpinner}>
						<CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
					</Backdrop>
					<Dialog header="Incluir Atividade"
									visible={visible}
									style={{ width: '43vw' }}
									footer={this.renderFooterAtividade('modalAtividadeInclusao')} 
									onHide={onHide}>
							<div className="row" style={{marginBottom: '12px'}}>
								<div className="col-sm-12">
									{this.state.pesquisaProcesso ? (
										<div style={{
											display: 'flex',
											alignItems: 'center',
											gap: '10px',
											background: '#f0f4ff',
											border: '1px solid #c7d4f0',
											borderRadius: '6px 6px 0 0',
											padding: '6px 12px',
											borderBottom: '1px solid #c7d4f0'
										}}>
											<span style={{fontSize: '11px', fontWeight: 700, color: '#5a72a0', textTransform: 'uppercase', letterSpacing: '0.5px', minWidth: '62px'}}>Processo</span>
											<span style={{color: '#1a3a6e', fontWeight: 600, fontSize: '13px'}}>{this.state.pesquisaProcesso}</span>
										</div>
									) : null}

									{this.state.partes?.length > 0 ? (
										<div style={{
											border: '1px solid #c7d4f0',
											borderTop: this.state.pesquisaProcesso ? 'none' : '1px solid #c7d4f0',
											borderRadius: this.state.pesquisaProcesso ? '0 0 6px 6px' : '6px',
											overflow: 'hidden'
										}}>
											<div style={{
												fontSize: '11px', fontWeight: 700, color: '#5a72a0',
												textTransform: 'uppercase', letterSpacing: '0.5px',
												padding: '4px 12px',
												background: '#f7f9ff',
												borderBottom: '1px solid #c7d4f0'
											}}>Partes</div>
											{this.state.partes.map((parte, index) => (
												<div key={index} style={{
													display: 'flex',
													alignItems: 'center',
													gap: '8px',
													padding: '5px 12px',
													borderBottom: index < this.state.partes.length - 1 ? '1px solid #eef1f8' : 'none',
													background: index % 2 === 0 ? '#fff' : '#fafbff',
													fontSize: '13px'
												}}>
													<span style={{color: '#1a3a6e', fontWeight: 500}}>{parte.pessoa.nome}</span>
													<span style={{color: '#b0bcd4', fontSize: '11px'}}>—</span>
													<span style={{color: '#5a72a0', fontSize: '11px'}}>{parte.nomeTipo}</span>
												</div>
											))}
										</div>
									) : this.state.pesquisaProcesso ? (
										<div style={{
											border: '1px solid #c7d4f0',
											borderTop: 'none',
											borderRadius: '0 0 6px 6px',
											padding: '6px 12px',
											fontSize: '12px',
											color: '#aab',
											background: '#fafbff'
										}}>Nenhuma parte cadastrada</div>
									) : null}
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
															options={this.state.titulos} style={{width: '100%', height: '32px'}}
															optionLabel="tituloExibir" 
															filter showClear filterBy="tituloExibir"
															onChange={e => this.setState({tituloAtividade: e.target.value})}
															id="tituloAtividade"
															emptyMessage=" "
															className="p-inputtext-sm p-d-block p-mb-1"
															placeholder="Título de Atividade"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6">
									<div className="form-group">
									<InputText id="processo" style={{width: '100%', height: '32px'}}
															type="text"
															disabled="true"
															value={this.state.grupoTrabalhoDescricao}
															className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<Dropdown value={this.state.subGrupo} style={{width: '100%', height: '32px'}} 
															options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
															optionLabel="nome" 
															emptyMessage=" "
															filter showClear filterBy="nome"
															onChange={(e) => this.setState({ subGrupo: e.value })} 
															id="subGrupoTrabalho"
															className="p-inputtext-sm p-d-block p-mb-1"
															placeholder="Sub-Grupo de Trabalho"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6">
									<div className="form-group">
										<MultiSelect inputId="multiselect" 
																value={this.state.responsavel} 
																options={this.state.responsaveis} 
																style={{width: '100%', height: '32px', padding_top: '1px'}} 
																onChange={(e) => this.setState({ responsavel: e.value })} 
																filter showClear filterBy="nome"
																optionLabel="nome" 
																placeholder="Responsáveis"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<MultiSelect inputId="multiselect" 
																value={this.state.interessado} 
																options={this.state.interessados} 
																style={{width: '100%', height: '32px', padding_top: '1px'}} 
																onChange={(e) => this.setState({ interessado: e.value })}  
																filter showClear filterBy="nome"
																optionLabel="nome" 
																placeholder="Interessados"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-3">
									<div className="form-group">
										<Calendar id="mask" 
															value={this.state.dtLimite} 
															onChange={(e) => this.setState({ dtLimite: e.value })} 
															locale="es"
															style={{width: '100%', height: '32px'}} 
															dateFormat="dd/mm/yy"
															mask="99/99/9999"
															placeholder="Data Limite"/>
									</div>
								</div>
								<div className="col-sm-3">
									<div className="form-group">
									<InputMask id="hora" style={{width: '100%', height: '32px'}}
														type="text"
														mask="99:99"
														value={this.state.hora}
														onChange={e => this.setState({hora: e.target.value})}
														className="p-inputtext-sm p-d-block p-mb-1"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<Calendar id="mask" 
															value={this.state.dtFatal} 
															onChange={(e) => this.setState({ dtFatal: e.value })} 
															locale="es"
															style={{width: '100%', height: '32px'}} 
															dateFormat="dd/mm/yy"
															mask="99/99/9999"
															placeholder="Prazo fatal"/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<InputTextarea id="descricao" 
																	type="text" 
																	autoComplete="nope"
																	style={{width: '100%'}} 
																	value={this.state.descricao}
																	onChange={e => this.setState({descricao: e.target.value})}
																	className="p-inputtext-sm p-d-block p-mb-1"
																	rows={5} cols={30}
																	placeholder="Descrição da Atividade"/>
									</div>
								</div>
							</div>
							<br></br>
							<div className="row" style={{marginLeft: '12px'}}>
								<div className="col-sm-8">
									<div className="form-group">
										<label htmlFor="importante">
											<Checkbox inputId="importante" 
																name="importante" 
																value="importante" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('importante') !== -1} />
											&nbsp;&nbsp;
											Importante
											&nbsp;&nbsp;
											<Checkbox inputId="urgente" 
																name="urgente" 
																value="urgente" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('urgente') !== -1} />
											&nbsp;&nbsp;
											Urgente
											&nbsp;&nbsp;
											<Checkbox inputId="privado" 
																name="privado" 
																value="privado" 
																onChange={this.onGrauChange} 
																checked={this.state.grau.indexOf('privado') !== -1} />
											&nbsp;&nbsp;
											Privado
										</label>
									</div>
								</div>
							</div>
					</Dialog>
				</>
		);
	}
}
AtividadeComponentInclusao.contextType = AuthContext;
export default AtividadeComponentInclusao;